import React from 'react';

import styled from '@emotion/styled';
import Flex from 'components/Flex';
import CustomIcon from 'components/customIcon';
import { numberPrettier } from 'utils/functions';

const Styled = styled.div`
    background: white;
    border-radius: 12px;
    padding: 20px;
    font-family: 'Segoe UI', sans-serif;
    border: 1px solid #d0d5e6;

    &.main {
        .details-list {
            display: flex;
            flex-direction: column;

            .item {
                display: flex;
                justify-content: space-between;
                color: #444;
                font-weight: 500;
                font-size: 13px;
                line-height: 170%;
                margin-bottom: 6px;
                padding: 3px 5px;

                &:nth-child(odd) {
                    background: #f0f2f8;
                }
            }
        }
    }

    .title {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 14px;
    }

    .change {
        display: flex;
        align-items: center;
        color: #ff0000;
        font-size: 13px;

        .percent {
            margin-right: 4px;
        }

        .amount {
            color: #333;
            margin-left: 4px;
        }
    }

    .total-income {
        font-weight: 600;
        font-size: 20px;
        line-height: 100%;
    }

    .details-list {
        display: flex;
        flex-direction: column;

        .item {
            display: flex;
            justify-content: space-between;
            color: #444;
            font-weight: 500;
            font-size: 13px;
            line-height: 170%;
            margin-bottom: 6px;
        }
    }

    .more-link {
        margin-top: 30px;
        font-weight: 400;
        font-size: 13px;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        gap: 5px;
        width: 100%;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const CardIncome = ({ data, onClick, isMain = false }) => {
    return (
        <Styled className={'card-income ' + (isMain ? 'main' : '')}>
            <div className="title">{data.period}</div>

            <Flex justify="space-between" align="center" mb={20}>
                <div className="change">
                    <span className="percent">↓ {data.change?.percent}%</span>
                    <span className="amount"> {data.change?.amount}</span>
                </div>

                <div className="total-income">{numberPrettier(data?.totalIncome)}</div>
            </Flex>

            <div className={'details-list'}>
                {data.details?.map((item, index) => (
                    <div className="item" key={index}>
                        <span>{item.label}</span>
                        <span>{item.amount}</span>
                    </div>
                ))}
            </div>

            {!isMain && (
                <div onClick={onClick} className="more-link" to={'/'}>
                    Детальніше <CustomIcon icon="ArrowRightCard" />
                </div>
            )}
        </Styled>
    );
};

export default CardIncome;
